import PrimarySubNavigation from './PrimarySubNavigation';

export { type PrimarySubNavigationProps, type Anchor } from './PrimarySubNavigation';
export default PrimarySubNavigation;
